export default "__VITE_PUBLIC_ASSET__55621b9c__"